export { default } from './AvatarPicker';

export type { Props as AvatarPickerProps } from './AvatarPicker';

import FormAvatarPicker from './FormAvatarPicker';

export { FormAvatarPicker };
